import * as projection from "@arcgis/core/geometry/projection";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";

export const makeKML = (view, outSR = new SpatialReference({ wkid: 4326 })) => {
  let colorlist = [
    "FF1400FF",
    "FF1478FF",
    "FF14B4FF",
    "FF78FF00",
    "FF7800F0",
    "FFFF7800",
    "FFAA78F0",
    "FFFF7878",
    "FFF0E614",
    "FF3C78F0",
    "FFA078F0",
  ];
  let colorlist80 = [
    "501400FF",
    "501478FF",
    "5014B4FF",
    "5078FF00",
    "507800F0",
    "50FF7800",
    "50AA78F0",
    "50FF7878",
    "50F0E614",
    "503C78F0",
    "50A078F0",
  ];

  let colorlist90 = [
    "641400FF",
    "641478FF",
    "6414B4FF",
    "6478FF00",
    "647800F0",
    "64FF7800",
    "64AA78F0",
    "64FF7878",
    "64F0E614",
    "643C78F0",
    "64A078F0",
  ];
  let colorindex = 0;
  let symcolor = colorlist[colorindex];
  let symcolor80 = colorlist80[colorindex];
  let symhighlight = "FFF0FF14";
  let symcolor90 = colorlist90[colorindex];

  let parentLayerTitle = "";
  let currentLayerTitle = "";
  let doneDownload = false;

  //view.when(() => {
    //JSON.parse(

    let layerFilter = view.map.allLayers.filter((layer) => {
      return layer.id === "selectionLayer";
    });
    //.map((layer) => {
    if (layerFilter.length > 0) {
      let layer = layerFilter.getItemAt(0);
      let graphicslist = (layer as GraphicsLayer).graphics["items"];
      if (graphicslist.length > 0) {
        let pregeolist = [];
        let masterKML = [
          '<?xml version="1.0" encoding="UTF-8"?>',
          '<kml xmlns="http://www.opengis.net/kml/2.2">',
          "<Document>",
          "<Folder>",
          // '<Style id="examplePolyStyle">',
          // "<PolyStyle>",
          // '<color>b211e8f0</color>',
          // '<colorMode>random</colorMode>',
          // '</PolyStyle>',
          // '</Style>'
        ];
        let masterDKML = [
          '<?xml version="1.0" encoding="UTF-8"?>',
          '<kml xmlns="http://www.opengis.net/kml/2.2">',
          "<Document>",
          //    "<Folder>",
          // '<Style id="examplePolyStyle">',
          // "<PolyStyle>",
          // '<color>b211e8f0</color>',
          // '<colorMode>random</colorMode>',
          // '</PolyStyle>',
          // '</Style>'
        ];
        graphicslist.forEach(function (item, index) {
          pregeolist.push(item.geometry);
        });
        projection.load().then(function () {
          let proj = projection.project(pregeolist, outSR);
          graphicslist.forEach(function (item, index) {
            let datelist = []
            graphicslist[index].popupTemplate.fieldInfos.forEach(function (fieldinfo) {
              if ((fieldinfo.format) && (fieldinfo.visible) ){
                if (fieldinfo.format.dateFormat) {
                  datelist.push(fieldinfo.fieldName);
                }
              }
            });
            // graphicslist[index].geometry = proj[index];

            // let geo = graphicslist[index].geometry;
            let geo = proj[index];
            let lyrname = graphicslist[index].parentLayerTitle;
            currentLayerTitle = lyrname;
            let fieldname = "";
            let addon;
            let buildlist = [];
            let content;
            graphicslist[index].popupTemplate.content.forEach(function (
              item,
              index
            ) {
              let type = item.type;
              let title = item.title;
              if (type == "fields") {
                if (item.title) {
                  if (item.title.length > 0) {
                    buildlist.push("<b>" + item.title + "</b>");
                    buildlist.push("<br>");
                  }
                }
              }
              if (type == "text" && item.text.length > 0) {
                if (item.text) {
                  if (item.text.length > 0) {
                    buildlist.push("<b>" + item.text + "</b>");
                    buildlist.push("<br>");
                  }
                }
              }
            });

            if (buildlist.length > 0) {
              content = buildlist.join("");
            }

            //if (graphicslist[index].popupTemplate.content[0].title.includes('{')){
            let AttributekeyChain = {};
            if (graphicslist[index].popupTemplate.title.includes("{")) {
              let popuptitle = graphicslist[index].popupTemplate.title;
              let customTitle = [];
              var arrStr =
                graphicslist[index].popupTemplate.title.split(/[{}]/);

              for (const [key, value] of Object.entries(
                graphicslist[index].attributes
              )) {
                AttributekeyChain[key.toLowerCase()] = key;
              }
              for (var i = 0; i < arrStr.length; i++) {

                if (AttributekeyChain[arrStr[i].toLowerCase()]) {
                  //graphicslist[index].attributes[arrStr[i]]
                  //    fieldname += ' '+ graphicslist[index].attributes[arrStr[i]]
                  customTitle.push(
                    " " +
                      graphicslist[index].attributes[
                        AttributekeyChain[arrStr[i].toLowerCase()]
                      ]
                  );
                } else {
                  if (i == 0) {
                    customTitle.push(arrStr[i]);
                  } else {
                    customTitle.push(" " + arrStr[i]);
                  }
                }
              }
              fieldname = customTitle.join("");
            } else {
              ////// I M P O R T A N T     DO NOT DELETE AS YET////////////////////////////////////////////////////
              // if (graphicslist[index].popupTemplate.title.split(':')){
              //     let intitle = graphicslist[index].popupTemplate.title.split(':')
              //     intitle.shift();
              //    fieldname = intitle.join('').trim()
              //  //   fieldname
              //    if (!fieldname){
              //     fieldname = graphicslist[index].popupTemplate.title
              //    }
              //    //.shift().join('').trim()
              //    if (!fieldname){
              //     fieldname = graphicslist[index].popupTemplate.title.replace(':','');
              //    }
              // } else {
              //   fieldname = graphicslist[index].popupTemplate.title
              // }

              ////// I M P O R T A N T////////////////////////////////////////////////////////////////////////
              fieldname = graphicslist[index].popupTemplate.title;
            }

            //   let makecdata = ['<h1>'+fieldname+'</h1>']
            let makecdata = [];
            if (content) {
              if (content.includes("{")) {
                let customTitle = [];
                var arrStr = content.split(/[{}]/);
                for (var i = 0; i < arrStr.length; i++) {

                  if (arrStr[i] in graphicslist[index].attributes) {
                    //    fieldname += ' '+ graphicslist[index].attributes[arrStr[i]]
                    customTitle.push(
                      " " + graphicslist[index].attributes[arrStr[i]]
                    );
                  } else {
                    if (i == 0) {
                      customTitle.push(arrStr[i]);
                    } else {
                      customTitle.push(" " + arrStr[i]);
                    }
                  }
                }
                addon = customTitle.join("");
              } else {
                addon = graphicslist[index].popupTemplate.title;
              }
              makecdata.push(addon);
            }
            makecdata.push("<br>");
            Object.keys(graphicslist[index].attributes).forEach(function (key) {
              let valuetxt;
              if (datelist.includes(key)){
                valuetxt = new Date(graphicslist[index].attributes[key])
              } else{
                valuetxt = graphicslist[index].attributes[key]
              }
              makecdata.push(
                "<b>" +
                  key +
                  "</b>: " +
                  valuetxt +
                  "<br>"
              );
            });

            // let description = JSON.stringify(graphicslist[index].attributes)
            //   .replace("{", "")
            //   .replace("}", "");

            let description =
              "<description><![CDATA[" +
              makecdata.join("") +
              "]]></description>";

            if (parentLayerTitle !== currentLayerTitle) {
              symcolor = colorlist[colorindex];
              symcolor80 = colorlist80[colorindex];
              symcolor90 = colorlist90[colorindex];
              // if (index == 0) {
              //   masterKML.push("<Folder>");
              // }
              if (index > 0) {
                masterKML.push("</Folder>");
                masterKML.push("<Folder>");
              }
              if (colorlist.length - 1 == colorindex) {
                colorindex = 0;
              } else {
                colorindex = colorindex + 1;
              }
              masterKML.push("<name>" + currentLayerTitle + "</name>");
              parentLayerTitle = currentLayerTitle;
            }
            // H I G H L I G H T - POLYGON
            // <Style id="sn_style">
            //   <PolyStyle>
            //     <color>00ff8080</color>
            //     <fill>0</fill>
            //   </PolyStyle>
            // </Style>
            // <Style id="sh_style">
            //   <PolyStyle>
            //     <color>7fff8080</color>
            //   </PolyStyle>
            // </Style>
            // <StyleMap id="msn_style">
            //   <Pair>
            //     <key>normal</key>
            //     <styleUrl>#sn_style</styleUrl>
            //   </Pair>
            //   <Pair>
            //     <key>highlight</key>
            //     <styleUrl>#sh_style</styleUrl>
            //   </Pair>
            // </StyleMap>
            // H I G H L I G H T - POINT
            //   <Style id="highlightState">
            //   <IconStyle>
            //     <Icon>
            //       <href>http://maps.google.com/mapfiles/kml/pal3/icon60.png</href>
            //     </Icon>
            //     <scale>1.1</scale>
            //   </IconStyle>
            //   <LabelStyle>
            //     <scale>1.1</scale>
            //     <color>ff0000c0</color>
            //   </LabelStyle>
            // </Style>
            // <StyleMap id="styleMapExample">
            //   <Pair>
            //     <key>normal</key>
            //     <styleUrl>#normalState</styleUrl>
            //   </Pair>
            //   <Pair>
            //     <key>highlight</key>
            //     <styleUrl>#highlightState</styleUrl>
            //   </Pair>
            // </StyleMap>
            masterKML.push("<Placemark>");
            if (geo.type == "multipoint") {
              masterKML.push("<name>" + fieldname + "</name>");
              masterKML.push(description);
              masterKML.push("<Style id='normalPlacemark'>");
              masterKML.push("<IconStyle>");
              masterKML.push("<scale>1</scale>");
              //   masterKML.push("<color>"+rgbaToKml(graphicslist[index].symbol.color)+"</color>");
              masterKML.push("<color>" + symcolor + "</color>");
              masterKML.push("<Icon>");
              masterKML.push(
                "<href>http://maps.google.com/mapfiles/kml/paddle/wht-blank.png</href>"
              );
              masterKML.push("</Icon>");
              masterKML.push("</IconStyle>");
              masterKML.push("</Style>");

              masterKML.push("<Style id='highlightPlacemark'>");
              masterKML.push("<IconStyle>");
              masterKML.push("<scale>1</scale>");
              //   masterKML.push("<color>"+rgbaToKml(graphicslist[index].symbol.color)+"</color>");
              masterKML.push("<color>" + symhighlight + "</color>");
              masterKML.push("<Icon>");
              masterKML.push(
                "<href>http://maps.google.com/mapfiles/kml/paddle/wht-blank.png</href>"
              );
              masterKML.push("</Icon>");
              masterKML.push("</IconStyle>");
              masterKML.push("</Style>");
              //        masterKML.push("<styleUrl>#exampleStyleMap</styleUrl>");

              masterKML.push('<StyleMap id="exampleStyleMap">');
              masterKML.push("<Pair>");
              masterKML.push("<key>normal</key>");
              masterKML.push("<styleUrl>#normalPlacemark</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("<Pair>");
              masterKML.push("<key>highlight</key>");
              masterKML.push("<styleUrl>#highlightPlacemark</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("</StyleMap>");
              //

              let pointlist = geo["points"];
              masterKML.push("<MultiGeometry>");
              pointlist.forEach(function (x) {
                masterKML.push(
                  "<Point><coordinates>" +
                    x[0] +
                    "," +
                    x[1] +
                    "</coordinates></Point>"
                );
              });
              masterKML.push("</MultiGeometry>");
            } else if (geo.type == "polygon") {
              let rings = geo.rings;
              masterKML.push("<name>" + fieldname + "</name>");
              masterKML.push(description);

              masterKML.push('<Style id="ns_PolyStyle">');
              // masterKML.push('<LineStyle>');
              // masterKML.push("<color>7f00ffff</color>");
              // masterKML.push('<width>4</width>');
              //masterKML.push('</LineStyle>');
              masterKML.push("<PolyStyle>");
              //  masterKML.push('<color>'+rgbaToKml(graphicslist[index].symbol.outline.color)+'</color>');
              masterKML.push("<color>" + symcolor90 + "</color>");
              //  masterKML.push('<colorMode>random</colorMode>');
              masterKML.push("</PolyStyle>");
              masterKML.push("</Style>");
              masterKML.push('<Style id="hs_PolyStyle">');
              // masterKML.push('<LineStyle>');
              // masterKML.push("<color>7f00ffff</color>");
              // masterKML.push('<width>4</width>');
              //masterKML.push('</LineStyle>');
              masterKML.push("<PolyStyle>");
              //  masterKML.push('<color>'+rgbaToKml(graphicslist[index].symbol.outline.color)+'</color>');
              masterKML.push("<color>" + symhighlight + "</color>");
              //  masterKML.push('<colorMode>random</colorMode>');
              masterKML.push("</PolyStyle>");
              masterKML.push("</Style>");
              masterKML.push('<StyleMap id="polyStyleMap">');
              masterKML.push("<Pair>");
              masterKML.push("<key>normal</key>");
              masterKML.push("<styleUrl>#ns_PolyStyle</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("<Pair>");
              masterKML.push("<key>highlight</key>");
              masterKML.push("<styleUrl>#hs_PolyStyle</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("</StyleMap>");
              // masterKML.push("<styleUrl>#examplePolyStyle</styleUrl>");
              masterKML.push("<Polygon>");
              //
              rings.forEach(function (ring, indx) {
                if (indx == 0) {
                  masterKML.push("<outerBoundaryIs>");
                } else {
                  masterKML.push("<innerBoundaryIs>");
                }

                masterKML.push("<LinearRing>");
                masterKML.push("<coordinates>");
                ring.forEach(function (x, idx) {
                  masterKML.push(x[0] + "," + x[1]);
                  if (idx + 1 == ring.length) {
                    masterKML.push(x[0] + "," + x[1]);
                  } else {
                    masterKML.push(x[0] + "," + x[1] + "\n");
                  }
                });
                masterKML.push("</coordinates>");
                masterKML.push("</LinearRing>");
                if (indx == 0) {
                  masterKML.push("</outerBoundaryIs>");
                } else {
                  masterKML.push("</innerBoundaryIs>");
                }
                //   masterKML.push('</outerBoundaryIs>');
              });
              masterKML.push("</Polygon>");
            } else if (geo.type == "point") {
              masterKML.push("<name>" + fieldname + "</name>");
              masterKML.push(description);
              masterKML.push('<Style id="normalPointPlacemark">');
              masterKML.push("<IconStyle>");
              masterKML.push("<scale>1</scale>");
              //  masterKML.push("<color>"+rgbaToKml(graphicslist[index].symbol.color)+"</color>");
              masterKML.push("<color>" + symcolor + "</color>");
              masterKML.push("<Icon>");
              masterKML.push(
                "<href>http://maps.google.com/mapfiles/kml/paddle/wht-blank.png</href>"
              );
              masterKML.push("</Icon>");
              masterKML.push("</IconStyle>");
              masterKML.push("</Style>");

              masterKML.push("<Style id='highlightPointPlacemark'>");
              masterKML.push("<IconStyle>");
              masterKML.push("<scale>1</scale>");
              //   masterKML.push("<color>"+rgbaToKml(graphicslist[index].symbol.color)+"</color>");
              masterKML.push("<color>" + symhighlight + "</color>");
              masterKML.push("<Icon>");
              masterKML.push(
                "<href>http://maps.google.com/mapfiles/kml/paddle/wht-blank.png</href>"
              );
              masterKML.push("</Icon>");
              masterKML.push("</IconStyle>");
              masterKML.push("</Style>");

              masterKML.push('<StyleMap id="pointStyleMap">');
              masterKML.push("<Pair>");
              masterKML.push("<key>normal</key>");
              masterKML.push("<styleUrl>#normalPointPlacemark</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("<Pair>");
              masterKML.push("<key>highlight</key>");
              masterKML.push("<styleUrl>#highlightPointPlacemark</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("</StyleMap>");
              // masterKML.push('<styleUrl>#placemark-red</styleUrl>')
              masterKML.push(
                "<Point><coordinates>" +
                  geo.x +
                  "," +
                  geo.y +
                  "</coordinates></Point>"
              );
            } else if (geo.type == "polyline") {
              let path = geo.paths;
              masterKML.push("<name>" + fieldname + "</name>");
              masterKML.push(description);
              masterKML.push("<Style id='sn_line'>");
              masterKML.push("<LineStyle>");
              masterKML.push("<color>ff00ffff</color>");
              //   masterKML.push("<color>"+symcolor+"</color>");
              masterKML.push("<width>4</width>");
              masterKML.push("</LineStyle>");
              masterKML.push("<PolyStyle>");
              //     masterKML.push("<color>7f00ff00</color>");
              masterKML.push("<color>" + symcolor + "</color>");
              masterKML.push("</PolyStyle>");
              masterKML.push("</Style>");
              masterKML.push("<Style id='sh_line'>>");
              masterKML.push("<LineStyle>");
              masterKML.push("<color>" + symhighlight + "</color>");
              //   masterKML.push("<color>"+symcolor+"</color>");
              masterKML.push("<width>4</width>");
              masterKML.push("</LineStyle>");
              masterKML.push("<PolyStyle>");
              //     masterKML.push("<color>7f00ff00</color>");
              masterKML.push("<color>" + symhighlight + "</color>");
              masterKML.push("</PolyStyle>");
              masterKML.push("</Style>");
              // masterKML.push("<styleUrl>#yellowLineGreenPoly</styleUrl>");
              masterKML.push('<StyleMap id="lineStyleMap">');
              masterKML.push("<Pair>");
              masterKML.push("<key>normal</key>");
              masterKML.push("<styleUrl>#sn_line</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("<Pair>");
              masterKML.push("<key>highlight</key>");
              masterKML.push("<styleUrl>#sh_line</styleUrl>");
              masterKML.push("</Pair>");
              masterKML.push("</StyleMap>");
              masterKML.push("<MultiGeometry>");
              // masterKML.push("<LineString>");
              // masterKML.push("<extrude>1</extrude>");
              // masterKML.push("<tessellate>1</tessellate>");
              // masterKML.push("<altitudeMode>absolute</altitudeMode>");
              //masterKML.push('<coordinates>');
              path.forEach(function (x) {
                masterKML.push("<LineString>");
                masterKML.push("<tessellate>1</tessellate>");
                masterKML.push("<coordinates>");
                x.forEach(function (xy, idx) {
                  if (idx + 1 == x.length) {
                    masterKML.push(xy[0] + "," + xy[1]);
                  } else {
                    masterKML.push(xy[0] + "," + xy[1] + "\n");
                  }
                });
                masterKML.push("</coordinates>");
                masterKML.push("</LineString>");
              });
              // masterKML.push("</coordinates>");
              //  masterKML.push("</LineString>");

              masterKML.push("</MultiGeometry>");
            }

            masterKML.push("</Placemark>");
            if (index == graphicslist.length - 1) {
              masterKML.push("</Folder>");
            }
          });
          let open = false;
          let close = false;
          let mylayer;
          let layercolor = {};
          let placemarkcount = 0;
          let folderset = [];
          let sets = {};
          let colorcount = 0;

          masterKML.forEach(function (x, idx) {
            if (x.includes("<Folder>")) {
              folderset = [];
              open = true;
              close = false;
              mylayer = masterKML[idx + 1]
                .replace("<name>", "")
                .replace("</name>", "");
              placemarkcount = 0;
            }

            if (open) {
              if (x.includes("<Placemark>")) {
                colorcount = 0;
                placemarkcount += 1;
              }
              if (x.includes("<color>")) {
                colorcount += 1;
                if (colorcount == 1) {
                  if (placemarkcount == 1) {
                    if (layercolor[mylayer]) {
                      x = layercolor[mylayer];
                    } else {
                      layercolor[mylayer] = x;
                    }
                  } else if (placemarkcount > 1) {
                    x = layercolor[mylayer];
                  }
                }
              }

              folderset.push(x);
            }

            if (x.includes("</Folder>")) {
              open = false;
              close = true;
              if (sets[mylayer]) {
                let setFound = sets[mylayer];
                setFound.pop();
                folderset.shift();
                folderset.shift();
                folderset.forEach(function (item) {
                  setFound.push(item);
                });
                sets[mylayer] = setFound;
              } else {
                sets[mylayer] = folderset;
              }
            }
          });
          for (let key in sets) {
            if (sets.hasOwnProperty(key)) {
              let value = sets[key];
              value.forEach(function (addme) {
                masterDKML.push(addme);
              });
            }
          }
          masterKML.push("</Document>");
          masterKML.push("</kml>");
          masterDKML.push("</Document>");
          masterDKML.push("</kml>");
          var contents = masterDKML.join("");
          //   var contents = masterKML.join("");
          var blob = new Blob([contents], { type: "text/plain" });
          var link = document.createElement("a");
          link.download = "data.kml";
          link.href = window.URL.createObjectURL(blob);
          link.click();
          doneDownload = true;
          return doneDownload;
        });
      } else {
        alert("Please make a selection.");
      }
    }
  //});
  return true;
};

const rgbaToKml = (rgba) => {
  var colors = {
    r: rgba.r,
    g: rgba.g || 0,
    b: rgba.b || 0,
  };

  var op = typeof rgba.a !== "undefined" ? rgba.a : 1;
  if (isNaN(op)) {
    // opacity is NaN
  } else if (op < 0 || op > 1) {
    // opacity is not in range
  }
  let op2 = op * 255;
  op = parseInt(op2.toString(), 10);
  op = op.toString(16);

  colors.b = colors.b.toString(16);
  colors.g = colors.g.toString(16);
  colors.r = colors.r.toString(16);
  if (op.length < 2) op = "0" + op;
  if (colors.b.length < 2) colors.b = "0" + colors.b;
  if (colors.g.length < 2) colors.g = "0" + colors.g;
  if (colors.r.length < 2) colors.r = "0" + colors.r;
  return op + colors.b + colors.g + colors.r;
};

const getSubString = (str) => {
  var mySubString = str.substring(str.indexOf("{") + 1, str.lastIndexOf("}"));
  return mySubString;
};
